<script lang="ts">
    import SomethingOnMap from "./SomethingOnMap.svelte";
    let className: string = "";
    export { className as class };
    export let open: boolean = true;
    export let showClose: boolean = false;
</script>

{#if open}
    <SomethingOnMap class={className}>
        {#if showClose}
            <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close" />
        {/if}
        <slot />
    </SomethingOnMap>
{/if}

<style>
    .btn-close {
        position: absolute;
        right: 1.5rem;
        top: 1.5rem;
    }
</style>
